import React from 'react';

const MessagePage: React.FC = () => {
  return (
    <div />
  );
};

export default MessagePage;
